import { StyledFlex } from '@dreryk/react-components';
import { Translate, useFormController } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import {
   PatientMedicalInformationRemoveFormBean,
   PatientMedicalInformationRemoveFormController,
} from './PatientMedicalInformationRemoveForm.types';
import { PatientMedicalInformationRemoveReasonField } from './fields/PatientMedicalInformationRemoveReasonField';
import { PatientMedicalInformationRemoveDescriptionField } from './fields/PatientMedicalInformationRemoveDescriptionField';

export type PatientMedicalInformationRemoveFormRenderProps = Pick<
   PatientMedicalInformationRemoveFormController,
   'handleSubmit' | 'trigger'
>;

type PatientMedicalInformationRemoveFormProps = Readonly<{
   children: (rendererProps: PatientMedicalInformationRemoveFormRenderProps) => JSX.Element;
}>;

export const PatientMedicalInformationRemoveForm = (props: PatientMedicalInformationRemoveFormProps): JSX.Element => {
   const { register, watch, handleSubmit, trigger } = useFormController<PatientMedicalInformationRemoveFormBean>({});

   const reason = watch('reason');

   return (
      <StyledFlex direction={'column'} gap={24}>
         <Translate>{translationKeys.areYouSureYouWantToMarkAsRemoved}</Translate>
         <StyledFlex direction={'column'} gap={8}>
            <PatientMedicalInformationRemoveReasonField register={register} />

            {reason === 'OTHER' ? <PatientMedicalInformationRemoveDescriptionField register={register} /> : null}
         </StyledFlex>

         {props.children({ handleSubmit: handleSubmit, trigger: trigger })}
      </StyledFlex>
   );
};
